import React from "react";
import { Spinner } from 'reactstrap';
import './styles.css'

export default function Loader(props) {
	const { isLoading } = props;
	return (
		isLoading &&
		<div className="loader-wrapper">
			<Spinner color="dark" />
		</div>
	);
}
